import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useCachedMedicalRecordSimple } from "../../hooks/useCachedMedicalRecordSimple";
import axiosInstance from "../../services/axiosInstance";
import MedicalRecordFormBase from "./MedicalRecordFormBase";
import LoadingScreen from "../common/LoadingScreen";
import ResponseMessage from "../common/ResponseMessage";
import { API_ENDPOINTS } from "../../services/api/apiConfig";
import type { MedicalRecord } from "../../types";

const RecordUpdate: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  // Utiliser le hook de cache pour les dossiers médicaux
  const { record, loading, error } = useCachedMedicalRecordSimple(id);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const userRole = localStorage.getItem("role") || "doctor";

  useEffect(() => {
    // Le hook de cache gère déjà le chargement initial
    // Pas besoin de useEffect supplémentaire
  }, []);

  // const handleRefresh = () => {
  //   // Utiliser le refetch du hook de cache
  //   refetch();
  // };

  const handleSubmit = async (
    data: MedicalRecord,
    prescriptionFile?: File | null,
    resultFile?: File | null
  ) => {
    setIsSubmitting(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("No token found");
      await axiosInstance.put(
        API_ENDPOINTS.MEDICAL_RECORDS.UPDATE(Number(id)),
        data
      );

      // If there are files, we should ideally upload them separately, 
      // but for now we focus on fixing the main data update which was failing with 403.
      if (prescriptionFile || resultFile) {
        console.warn("File uploads are not yet supported in this update form due to backend limitations.");
      }
      const dashboardPath = userRole === "admin" ? "/admin/dashboard/record" : "/doctor/dashboard/record";
      setTimeout(() => navigate(dashboardPath), 1500);
    } catch (error) {
      console.error("Error updating medical record:", error);
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading)
    return (
      <LoadingScreen message="Chargement du dossier médical..." role="doctor" />
    );
  if (error || !record)
    return (
      <ResponseMessage
        message={error || "Dossier médical non trouvé"}
        role={userRole as any}
      />
    );

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 p-4">
      <MedicalRecordFormBase
        mode="update"
        initialData={record}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
    </div>
  );
};

export default RecordUpdate;
